export default __webpack_public_path__ + "static/media/gallery (8).c1263720.png";